import { MedicalRecord } from '../types';
import { usePatients } from '../hooks/usePatients';
import { useProfessionals } from '../hooks/useProfessionals';
import { X, FileText } from 'lucide-react';

interface MedicalRecordDetailsProps {
  record: MedicalRecord;
  onClose: () => void;
}

export default function MedicalRecordDetails({ record, onClose }: MedicalRecordDetailsProps) {
  const { patients } = usePatients();
  const { professionals } = useProfessionals();
  
  const patient = patients.find(p => p.id === record.patientId);
  const professional = professionals.find(p => p.id === record.professionalId);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Detalhes do Prontuário</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div className="bg-medical-50 rounded-lg p-4">
            <h3 className="text-lg font-bold text-gray-900">{patient?.name || 'Paciente não encontrado'}</h3>
            <p className="text-gray-600">Dr(a). {professional?.name || 'Profissional não encontrado'}</p>
            <p className="text-sm text-gray-500">{new Date(record.date).toLocaleDateString('pt-BR')}</p>
          </div>

          <div>
            <h4 className="text-lg font-medium text-gray-900 mb-2">Diagnóstico</h4>
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-sm text-gray-900">{record.diagnosis}</p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-medium text-gray-900 mb-2">Queixa Principal</h4>
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-sm text-gray-900">{record.chiefComplaint}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}